<div class="report-col" *ngFor="let column of columns">
	<div class="panel-toggle-button" (click)="openCols[column.title] = !openCols[column.title]" [class.open]="openCols[column.title]">
		<span class="title">{{ column.title }}</span>
		<span class="values" *ngIf="!openCols[column.title]">
			<ng-container *ngFor="let colVal of column.values; let i = index;">
				<span class="val" *ngIf="colVal !== 'mediaclip' && i < 4">
					<i class="fa fa-check"></i> {{ colVal | valueToLabel: column.options }}
				</span>
			</ng-container>
			<span class="val" *ngIf="column.values.length > 4">
				<i class="fa fa-check"></i> {{ column.values.length - 4 }} {{ 'MORE' | translate | lowercase }}
			</span>
		</span>
		<div class="toggle-icon">
			<i class="fa fa-chevron-right"></i>
			<i class="fa fa-chevron-down"></i>
		</div>
	</div>
	<div *ngIf="column?.options?.length && openCols[column.title]" class="report-column-container content">
		<div class="column-content">
			<bb-checkbox-list
				[(ngModel)]="column.values"
				(ngModelChange)="columnChanged(column, $event)"
				[options]="column.options"
				[showMoreLimit]="column.limit"
				[disabledOptions]="column.property === 'metrics' ? disabledOptions : (column.property === 'mediaclip' ? ['id'] : null)"
				[numColumns]="3" theme="light-v2"></bb-checkbox-list>
			<bb-info *ngIf="column.property === 'metrics' && disableInitsAndPercentages" [contents]="'HELP.REPORT_NO_PLAYER_LOADS_AND_PERCENTAGES' | translate" [icon]="'warning'"></bb-info>
		</div>
	</div>
</div>
